import React from 'react';
import { List, LayoutGrid } from 'lucide-react';

/**
 * ViewToggle — Toggle between List and Kanban views
 *
 * Props:
 *   mode: 'list' | 'kanban'
 *   onChange: (mode) => void
 */
const ViewToggle = ({ mode, onChange }) => {
  const buttons = [
    { id: 'list', icon: List, label: 'Lista' },
    { id: 'kanban', icon: LayoutGrid, label: 'Kanban' },
  ];

  return (
    <div
      style={{
        display: 'inline-flex',
        alignItems: 'center',
        background: 'var(--dp-bg-card, rgba(30,30,30,0.5))',
        border: '1px solid var(--dp-border-subtle, rgba(255,255,255,0.06))',
        borderRadius: '10px',
        padding: '3px',
        gap: '2px',
      }}
    >
      {buttons.map(({ id, icon: Icon, label }) => {
        const isActive = mode === id;
        return (
          <button
            key={id}
            onClick={() => onChange(id)}
            title={`Visualização em ${label}`}
            style={{
              display: 'flex',
              alignItems: 'center',
              gap: '5px',
              padding: '6px 12px',
              borderRadius: '8px',
              border: 'none',
              fontSize: '12px',
              fontWeight: isActive ? 600 : 500,
              fontFamily: 'var(--dp-font)',
              cursor: 'pointer',
              transition: 'all 0.2s ease',
              background: isActive
                ? 'var(--dp-blue-500, #0DAEFF)'
                : 'transparent',
              color: isActive
                ? '#fff'
                : 'var(--dp-text-secondary, #A0A0A0)',
              boxShadow: isActive
                ? '0 2px 8px rgba(13, 174, 255, 0.3)'
                : 'none',
            }}
            onMouseEnter={(e) => {
              if (!isActive) {
                e.currentTarget.style.background =
                  'var(--dp-bg-card-hover, rgba(255,255,255,0.05))';
                e.currentTarget.style.color =
                  'var(--dp-text-primary, #F5F5F5)';
              }
            }}
            onMouseLeave={(e) => {
              if (!isActive) {
                e.currentTarget.style.background = 'transparent';
                e.currentTarget.style.color =
                  'var(--dp-text-secondary, #A0A0A0)';
              }
            }}
          >
            <Icon size={14} />
            <span>{label}</span>
          </button>
        );
      })}
    </div>
  );
};

export default ViewToggle;
